module.exports = __webpack_public_path__ + "static/media/arrow-forward.ea0e042d.svg";